import { Box, Grid, Typography, Card, CardContent, CardMedia, useMediaQuery } from "@mui/material";
import productionImage from "../../assets/image/landing/production.png";
import partnershipImage from "../../assets/image/landing/partnership.png";
import innovativeImage from "../../assets/image/landing/innovative.png";

const propositions = [
    {
        title: "Local Production Focus",
        description: "RDX prioritizes local manufacturing of defense technologies, meeting SRDP R.A. 12024 objectives to minimize imports and enhance local economic development.",
        image: productionImage,
    },
    {
        title: "Strong Partnerships",
        description: "RDX partners with both local and international firms, utilizing diverse expertise to deliver comprehensive solutions.",
        image: partnershipImage,
    },
    {
        title: "Innovative Product Range",
        description: <span>RDX offers a wide array of defense products and infrastructure solutions, making it a &nbsp; one-stop provider for national defense needs.</span>,
        image: innovativeImage,
    },
];

const LandingCompetitiveAdvantageComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)');

    return (
        <Box sx={{ backgroundColor: '#f2f2f2', paddingBottom: 10, paddingTop: 10 }}>
            <Grid container sx={{ textAlign: 'start', position: 'relative', marginTop: 4 }}>
                <Grid item xs={12}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 60, textAlign: 'center', color: '#08244d' }}>
                        {/* Unique Selling Propositions */}
                        Competitive Advantage
                    </Typography>
                    <br />
                </Grid>
                {propositions.map((prop, index) => (
                    <Grid item xs={12} sm={4} key={index} sx={{ display: 'flex', justifyContent: 'center', margin: isSmallScreen ? 1 : 0 }}>
                        <Card sx={{ margin: 2, display: 'flex', flexDirection: 'column', height: '100%', width: isSmallScreen ? '100%' : '80%' }}>
                            <CardMedia
                                component="img"
                                height="320"
                                image={prop.image}
                                alt={prop.title}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography sx={{ fontSize: 24, color: '#08244d', textAlign: 'justify' }}>
                                    <b style={{ color: '#08244d' }}>{prop.title}</b> - {prop.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                ))}
            </Grid>
        </Box>
    );
};

export default LandingCompetitiveAdvantageComponent;
